export default "__VITE_ASSET__BAvkDBkl__"